module.exports = __webpack_public_path__ + "static/media/fly0104.20f50f13.webp";